const NAME = "HOME_PAGE";

export default NAME;
